import { Link } from 'react-router-dom';

interface BrandProps {
  className?: string;
  compact?: boolean;
  linked?: boolean;
  onClick?: () => void;
}

export function Brand({ className = '', compact = false, linked = true, onClick }: BrandProps) {
  const content = (
    <>
      <img
        src="/brand/sales-smash-mark.svg"
        alt=""
        width={compact ? 30 : 34}
        height={compact ? 30 : 34}
        className="shrink-0"
      />
      <span className={`font-bold tracking-[-0.045em] text-ff-ink ${compact ? 'text-base' : 'text-lg'}`}>
        sales<span className="text-ff-orange">smash</span>
      </span>
    </>
  );

  const classes = `inline-flex items-center gap-2.5 ${className}`;
  return linked ? (
    <Link to="/" className={classes} aria-label="Sales Smash home" onClick={onClick}>
      {content}
    </Link>
  ) : (
    <div className={classes} onClick={onClick}>{content}</div>
  );
}
